<div class="modal-header" id="dashboard-button-modal-title">
    <h3 class="modal-title" id="modal-title">{{ model.titleText }}</h3>
</div>
<div class="modal-body" id="modal-body">
    <p class="user-select-auto" [innerHTML]="model.bodyText"></p>
</div>
<div class="modal-footer">
    @if (!model.forceDashboard) {
        <button class="btn btn-primary" type="button" (click)="okClick()">
            {{ 'MODAL_OK' | translate }}
        </button>
    }
    <button class="btn btn-primary" type="button" (click)="openDashboard()">
        {{ 'APP_HEADER_DASHBOARD_TITLE' | translate }}
    </button>
</div>
